import { ButtonIcon } from 'components/Button';
import { Icon } from 'components/Icon';
import { ModalDiia } from 'components/ModalDiia';
import PropTypes from 'prop-types';
import Checkbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';
import React, { useEffect, useState } from 'react';
import '../style.scss';
import { TableLabel, TableProp, TableValueDynamic, TableValueDynamicAutoComplete } from './TableUtils';

const regularPassportMask = 'AA 999999 від 99.99.9999';
const idPassportMask = '999999999 від 99.99.9999';

const regularPassportPlaceholder = 'AA 123456 від 12.06.1999';
const idPassportPlaceholder = '123456789 від 12.06.1999';

const ClientRequisites = ({ client, onChange, historyParams }) => {
  const [changeClient, setChangeClient] = useState(client);
  const [edit, setEdit] = useState(false);
  const [isIdCard, setIsIdCard] = useState(false);
  const [modalDiia, setModalDiia] = useState(false);

  const onIdCardChange = (event) => {
    setIsIdCard(event.target.checked);
    handleChange('document', '');
  };

  useEffect(() => {
    setChangeClient(client);
    setEdit(false);
  }, [client]);

  const toggleEdit = (toggle) => {
    return () => {
      setEdit(toggle);

      if (toggle === false) {
        setChangeClient(client);
      }
    };
  };

  const handleDIIAClick = (value) => {
    return () => {
      setModalDiia(value);
    };
  };

  const handleSave = () => {
    onChange(changeClient);
  };

  const handleCopy = () => {
    if (edit) {
      setChangeClient({
        ...changeClient,
        AddrFact: changeClient.AddrOfficial,
      });
    }
  };

  const handleViberRedirectClick = (phone) => {
    return () => {
      window.open(`viber://chat?number=${phone}`, '_blank');
    };
  };
  const handleTelegramRedirectClick = (phone) => {
    return () => {
      let match = phone.replace(/\D/g, '').match(/^(\d{3})(\d{3})(\d{4})$/)[0];
      if (match.substring(0, 2) !== '38') {
        match = `38${match}`;
      }
      window.open(`https://t.me/+${match}`, '_blank');
    };
  };

  const handleChange = (key, value) => {
    setChangeClient({ ...changeClient, [key]: value });
  };

  return (
    <>
      <div className="requisites-grid">
        <TableProp title="ФИО" icon={changeClient.isPendingDeletion ? 'userverify-pending-deletition' : 'userverify'} />
        <TableValueDynamic
          value={changeClient.FIO}
          onChange={(value) => handleChange('FIO', value)}
          canEdit={edit && client.isTemporary && !client.isCreatedFromDiia}
          placeholder="ФИО"
        />

        <TableProp title="Телефон осн." icon="phone" />
        <div className="phone-container">
          <TableValueDynamicAutoComplete
            historyParams={historyParams}
            value={changeClient.PhMain}
            onChange={(value) => handleChange('PhMain', value)}
            canEdit={edit}
            mask="+380 99 999 99 99"
            placeholder="+380 XX XXX XX XX"
            isMasked={true}
            search="search"
          />
          {changeClient.PhMain && (
            <>
              <Icon
                name="viber-redirect"
                style={{ cursor: 'pointer' }}
                tooltipText="Написать в Viber"
                onClick={handleViberRedirectClick(changeClient.PhMain)}
              />
              <Icon
                name="telegram-redirect"
                style={{ cursor: 'pointer' }}
                tooltipText="Написать в Telegram"
                onClick={handleTelegramRedirectClick(changeClient.PhMain)}
              />
            </>
          )}
        </div>
        <TableProp title="Телефон доп." icon="phone" />
        <div className="phone-container">
          <TableValueDynamicAutoComplete
            value={changeClient.PhAdd}
            historyParams={historyParams}
            onChange={(value) => handleChange('PhAdd', value)}
            canEdit={edit}
            mask="+380 99 999 99 99"
            placeholder="+380 XX XXX XX XX"
            isMasked={true}
            search="search"
          />
          {changeClient.PhAdd && (
            <>
              <Icon
                name="viber-redirect"
                style={{ cursor: 'pointer' }}
                tooltipText="Написать в Viber"
                onClick={handleViberRedirectClick(changeClient.PhAdd)}
              />
              <Icon
                name="telegram-redirect"
                style={{ cursor: 'pointer' }}
                tooltipText="Написать в Telegram"
                onClick={handleTelegramRedirectClick(changeClient.PhAdd)}
              />
            </>
          )}
        </div>
        <TableProp title="ИНН" icon="hashtag" />
        <TableValueDynamicAutoComplete
          value={changeClient.INN}
          onChange={(value) => handleChange('INN', value)}
          canEdit={edit && client.isTemporary && !client.isCreatedFromDiia}
          mask="9999999999"
          placeholder="XXXXXXXXXX"
          isMasked={!client.INN}
          search="INN"
        />

        <TableProp title="Документ" icon="passport" />
        <div className="passport-field">
          <TableValueDynamic
            value={changeClient.document}
            onChange={(value) => handleChange('document', value)}
            canEdit={edit && client.isTemporary && (!client.isCreatedFromDiia || !client.document)}
            placeholder={isIdCard ? idPassportPlaceholder : regularPassportPlaceholder}
            mask={isIdCard ? idPassportMask : regularPassportMask}
            isMasked={!client.document}
            className="margin-adjust"
          />
          {edit && client.isTemporary && !client.document && (
            <label className="id-card-checkbox">
              <Checkbox checked={isIdCard} onChange={onIdCardChange} />
              ID-карта
            </label>
          )}
        </div>

        <TableProp title="Адр. прописки" icon="location" />
        <TableValueDynamic
          value={changeClient.AddrOfficial}
          onChange={(value) => handleChange('AddrOfficial', value)}
          canEdit={edit && client.isTemporary && (!client.isCreatedFromDiia || !client.AddrOfficial)}
          placeholder="Адрес прописки"
        />

        <TableLabel
          show={edit && client.isTemporary}
          onClick={handleCopy}
          text="Проживает по адресу прописки"
          icon="copy"
          rounded={true}
        />

        <TableProp title="Адр. прожив." icon="location" />
        <TableValueDynamic
          value={changeClient.AddrFact}
          onChange={(value) => handleChange('AddrFact', value)}
          canEdit={edit && client.isTemporary}
          placeholder="Адрес проживания"
        />
      </div>

      <div className="buttons-block" style={{ margin: '0' }}>
        {edit ? (
          <>
            <ButtonIcon className="btn-main btn-save" onClick={toggleEdit(false)} icon="save" text="Отмена" />

            <ButtonIcon className="btn-main btn-save" onClick={handleSave} icon="save" text="Сохранить" />
          </>
        ) : (
          <ButtonIcon className="btn-main btn-save" onClick={toggleEdit(true)} icon="edit" text="Редактировать" />
        )}
        <div className="diia-button">
          <Icon name="diia-edit" onClick={handleDIIAClick(true)} />
        </div>
        {modalDiia && <ModalDiia clientId={client?.id} onClose={handleDIIAClick(false)} />}
      </div>
    </>
  );
};

ClientRequisites.propTypes = {
  client: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  historyParams: PropTypes.object,
};

ClientRequisites.defaultProps = {
  onChange: () => {},
  historyParams: {},
};

export { ClientRequisites };
